var _path, _path2, _mask, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongWendang3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2a1 1 0 011-1h6.293a1 1 0 01.707.293L13.207 5a1 1 0 01.293.707V7a.5.5 0 01-1 0V5.707L8.793 2H2.5v12h2a.5.5 0 010 1h-2a1 1 0 01-1-1V2z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5v4h4",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tongyong_wendang3_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 15C7.507 15 6.5 13.98 6.5 12.725c0-1.174.879-2.14 2.007-2.262A2.578 2.578 0 0111.001 8.5c1.203 0 2.213.835 2.494 1.963a2.266 2.266 0 012.005 2.262c0 1.256-1.007 2.275-2.25 2.275h-4.5z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15h1v-1h-1v1zm-.243-4.537l.108.994.694-.075.169-.677-.97-.242zm4.988 0l-.97.242.168.676.693.076.109-.994zM13.25 15v-1h-1v1h1zm0 0v1h1v-1h-1zm-4.5 0h-1v1h1v-1zm0-1c-.68 0-1.25-.56-1.25-1.275h-2C5.5 14.523 6.945 16 8.75 16v-2zM7.5 12.725c0-.666.498-1.2 1.115-1.268L8.4 9.47a3.266 3.266 0 00-2.9 3.256h2zm1.978-2.02c.174-.7.797-1.205 1.523-1.205v-2c-1.68 0-3.076 1.165-3.464 2.721l1.94.484zM11 9.5c.726 0 1.35.505 1.524 1.205l1.94-.483C14.078 8.665 12.681 7.5 11.001 7.5v2zm2.385 1.957a1.266 1.266 0 011.114 1.268h2a3.266 3.266 0 00-2.896-3.256l-.218 1.988zm1.114 1.268c0 .715-.57 1.275-1.25 1.275v2c1.805 0 3.25-1.477 3.25-3.275h-2zM12.25 15h2-2zm1-1h-4.5v2h4.5v-2zm-3.5 1h-2 2z",
    fill: "#3F465C",
    mask: "url(#tongyong_wendang3_svg__a)"
  })));
}
export default __webpack_public_path__ + "static/tongyong_wendang3.438731a2.svg";
export { SvgTongyongWendang3 as ReactComponent };